import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    primary: {
      main: '#007bff',
    },
    secondary: {
      main: '#6c757d',
    },
    // Add more colors as needed
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: 'var(--darkPurple)',
          borderColor: 'var(--darkPurple)',
          borderRadius: '2rem',
          borderWidth: '0.2rem',
          backgroundColor: 'var(--white)',
          '&:hover': {
            backgroundColor: 'var(--white)',
          },
          '&:focus': {
            backgroundColor: 'var(--white)',
          },
          '&:active': {
            backgroundColor: 'var(--white)',
          },
          '&.MuiButton-outlined': { // Add this rule
            borderColor: 'var(--darkPurple)',
            '&:hover': {
              borderColor: 'var(--darkPurple)',
            },
            '&:focus': {
              borderColor: 'var(--darkPurple)',
            },
            '&:active': {
              borderColor: 'var(--darkPurple)',
            },
          },
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;